"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zonesMap = exports.defaultStart = void 0;
exports.defaultStart = "19700101T000000";
exports.zonesMap = new Map([
    [
        "Africa/Abidjan",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Accra",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Addis_Ababa",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Africa/Algiers",
        {
            "s": {
                "f": "+0100",
                "n": "CET"
            }
        }
    ],
    [
        "Africa/Asmara",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Africa/Bamako",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Bangui",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Banjul",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Bissau",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Blantyre",
        {
            "s": {
                "f": "+0200",
                "n": "CAT"
            }
        }
    ],
    [
        "Africa/Brazzaville",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Bujumbura",
        {
            "s": {
                "f": "+0200",
                "n": "CAT"
            }
        }
    ],
    [
        "Africa/Cairo",
        {
            "s": {
                "f": "+0200",
                "n": "EET"
            }
        }
    ],
    [
        "Africa/Casablanca",
        {
            "s": {
                "f": "+0100",
                "n": "+01"
            }
        }
    ],
    [
        "Africa/Ceuta",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Africa/Conakry",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Dakar",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Dar_es_Salaam",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Africa/Djibouti",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Africa/Douala",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/El_Aaiun",
        {
            "s": {
                "f": "+0100",
                "n": "+01"
            }
        }
    ],
    [
        "Africa/Freetown",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Gaborone",
        {
            "s": {
                "f": "+0200",
                "n": "CAT"
            }
        }
    ],
    [
        "Africa/Harare",
        {
            "s": {
                "f": "+0200",
                "n": "CAT"
            }
        }
    ],
    [
        "Africa/Johannesburg",
        {
            "s": {
                "f": "+0200",
                "n": "SAST"
            }
        }
    ],
    [
        "Africa/Juba",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Africa/Kampala",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Africa/Khartoum",
        {
            "s": {
                "f": "+0200",
                "n": "CAT"
            }
        }
    ],
    [
        "Africa/Kigali",
        {
            "s": {
                "f": "+0200",
                "n": "CAT"
            }
        }
    ],
    [
        "Africa/Kinshasa",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Lagos",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Libreville",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Lome",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Luanda",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Lubumbashi",
        {
            "s": {
                "f": "+0200",
                "n": "CAT"
            }
        }
    ],
    [
        "Africa/Lusaka",
        {
            "s": {
                "f": "+0200",
                "n": "CAT"
            }
        }
    ],
    [
        "Africa/Malabo",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Maputo",
        {
            "s": {
                "f": "+0200",
                "n": "CAT"
            }
        }
    ],
    [
        "Africa/Maseru",
        {
            "s": {
                "f": "+0200",
                "n": "SAST"
            }
        }
    ],
    [
        "Africa/Mbabane",
        {
            "s": {
                "f": "+0200",
                "n": "SAST"
            }
        }
    ],
    [
        "Africa/Mogadishu",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Africa/Monrovia",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Nairobi",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Africa/Ndjamena",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Niamey",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Nouakchott",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Ouagadougou",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Africa/Porto-Novo",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Sao_Tome",
        {
            "s": {
                "f": "+0100",
                "n": "WAT"
            }
        }
    ],
    [
        "Africa/Tripoli",
        {
            "s": {
                "f": "+0200",
                "n": "EET"
            }
        }
    ],
    [
        "Africa/Tunis",
        {
            "s": {
                "f": "+0100",
                "n": "CET"
            }
        }
    ],
    [
        "Africa/Windhoek",
        {
            "s": {
                "f": "+0200",
                "n": "CAT"
            }
        }
    ],
    [
        "America/Adak",
        {
            "s": {
                "f": "-0900",
                "t": "-1000",
                "n": "HST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-1000",
                "t": "-0900",
                "n": "HDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Anchorage",
        {
            "s": {
                "f": "-0800",
                "t": "-0900",
                "n": "AKST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0900",
                "t": "-0800",
                "n": "AKDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Anguilla",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Antigua",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Araguaina",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/Buenos_Aires",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/Catamarca",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/Cordoba",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/Jujuy",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/La_Rioja",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/Mendoza",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/Rio_Gallegos",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/Salta",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/San_Juan",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/San_Luis",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/Tucuman",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Argentina/Ushuaia",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Aruba",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Asuncion",
        {
            "s": {
                "f": "-0300",
                "t": "-0400",
                "n": "-04",
                "s": "19700322T000000",
                "r": {
                    "m": 3,
                    "d": "4SU"
                }
            },
            "d": {
                "f": "-0400",
                "t": "-0300",
                "n": "-03",
                "s": "19701004T000000",
                "r": {
                    "m": 10,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Atikokan",
        {
            "s": {
                "f": "-0500",
                "n": "EST"
            }
        }
    ],
    [
        "America/Bahia_Banderas",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700405T020000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Bahia",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Barbados",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Belem",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Belize",
        {
            "s": {
                "f": "-0600",
                "n": "CST"
            }
        }
    ],
    [
        "America/Blanc-Sablon",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Boa_Vista",
        {
            "s": {
                "f": "-0400",
                "n": "-04"
            }
        }
    ],
    [
        "America/Bogota",
        {
            "s": {
                "f": "-0500",
                "n": "-05"
            }
        }
    ],
    [
        "America/Boise",
        {
            "s": {
                "f": "-0600",
                "t": "-0700",
                "n": "MST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0700",
                "t": "-0600",
                "n": "MDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Cambridge_Bay",
        {
            "s": {
                "f": "-0600",
                "t": "-0700",
                "n": "MST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0700",
                "t": "-0600",
                "n": "MDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Campo_Grande",
        {
            "s": {
                "f": "-0400",
                "n": "-04",
                "s": "19700215T000000",
                "r": {
                    "m": 2,
                    "d": "3SU"
                }
            },
            "d": {
                "f": "-0400",
                "t": "-0300",
                "n": "-03",
                "s": "19701101T000000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Cancun",
        {
            "s": {
                "f": "-0500",
                "n": "EST"
            }
        }
    ],
    [
        "America/Caracas",
        {
            "s": {
                "f": "-0400",
                "n": "-04"
            }
        }
    ],
    [
        "America/Cayenne",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Cayman",
        {
            "s": {
                "f": "-0500",
                "n": "EST"
            }
        }
    ],
    [
        "America/Chicago",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Chihuahua",
        {
            "s": {
                "f": "-0600",
                "t": "-0700",
                "n": "MST",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "-0700",
                "t": "-0600",
                "n": "MDT",
                "s": "19700405T020000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Costa_Rica",
        {
            "s": {
                "f": "-0600",
                "n": "CST"
            }
        }
    ],
    [
        "America/Creston",
        {
            "s": {
                "f": "-0700",
                "n": "MST"
            }
        }
    ],
    [
        "America/Cuiaba",
        {
            "s": {
                "f": "-0400",
                "n": "-04",
                "s": "19700215T000000",
                "r": {
                    "m": 2,
                    "d": "3SU"
                }
            },
            "d": {
                "f": "-0400",
                "t": "-0300",
                "n": "-03",
                "s": "19701101T000000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Curacao",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Danmarkshavn",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "America/Dawson_Creek",
        {
            "s": {
                "f": "-0700",
                "n": "MST"
            }
        }
    ],
    [
        "America/Dawson",
        {
            "s": {
                "f": "-0700",
                "t": "-0800",
                "n": "PST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0800",
                "t": "-0700",
                "n": "PDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Denver",
        {
            "s": {
                "f": "-0600",
                "t": "-0700",
                "n": "MST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0700",
                "t": "-0600",
                "n": "MDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Detroit",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Dominica",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Edmonton",
        {
            "s": {
                "f": "-0600",
                "t": "-0700",
                "n": "MST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0700",
                "t": "-0600",
                "n": "MDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Eirunepe",
        {
            "s": {
                "f": "-0500",
                "n": "-05"
            }
        }
    ],
    [
        "America/El_Salvador",
        {
            "s": {
                "f": "-0600",
                "n": "CST"
            }
        }
    ],
    [
        "America/Fort_Nelson",
        {
            "s": {
                "f": "-0700",
                "n": "MST"
            }
        }
    ],
    [
        "America/Fortaleza",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Glace_Bay",
        {
            "s": {
                "f": "-0300",
                "t": "-0400",
                "n": "AST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0400",
                "t": "-0300",
                "n": "ADT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Godthab",
        {
            "s": {
                "f": "-0200",
                "t": "-0300",
                "n": "-03",
                "s": "19701024T230000",
                "r": {
                    "m": 10,
                    "d": "-1SA"
                }
            },
            "d": {
                "f": "-0300",
                "t": "-0200",
                "n": "-02",
                "s": "19700328T220000",
                "r": {
                    "m": 3,
                    "d": "-1SA"
                }
            }
        }
    ],
    [
        "America/Goose_Bay",
        {
            "s": {
                "f": "-0300",
                "t": "-0400",
                "n": "AST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0400",
                "t": "-0300",
                "n": "ADT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Grand_Turk",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Grenada",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Guadeloupe",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Guatemala",
        {
            "s": {
                "f": "-0600",
                "n": "CST"
            }
        }
    ],
    [
        "America/Guayaquil",
        {
            "s": {
                "f": "-0500",
                "n": "-05"
            }
        }
    ],
    [
        "America/Guyana",
        {
            "s": {
                "f": "-0400",
                "n": "-04"
            }
        }
    ],
    [
        "America/Halifax",
        {
            "s": {
                "f": "-0300",
                "t": "-0400",
                "n": "AST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0400",
                "t": "-0300",
                "n": "ADT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Havana",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "CST",
                "s": "19701101T010000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "CDT",
                "s": "19700308T000000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Hermosillo",
        {
            "s": {
                "f": "-0700",
                "n": "MST"
            }
        }
    ],
    [
        "America/Indiana/Indianapolis",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Indiana/Knox",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Indiana/Marengo",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Indiana/Petersburg",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Indiana/Tell_City",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Indiana/Vevay",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Indiana/Vincennes",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Indiana/Winamac",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Inuvik",
        {
            "s": {
                "f": "-0600",
                "t": "-0700",
                "n": "MST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0700",
                "t": "-0600",
                "n": "MDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Iqaluit",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Jamaica",
        {
            "s": {
                "f": "-0500",
                "n": "EST"
            }
        }
    ],
    [
        "America/Juneau",
        {
            "s": {
                "f": "-0800",
                "t": "-0900",
                "n": "AKST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0900",
                "t": "-0800",
                "n": "AKDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Kentucky/Louisville",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Kentucky/Monticello",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Kralendijk",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/La_Paz",
        {
            "s": {
                "f": "-0400",
                "n": "-04"
            }
        }
    ],
    [
        "America/Lima",
        {
            "s": {
                "f": "-0500",
                "n": "-05"
            }
        }
    ],
    [
        "America/Los_Angeles",
        {
            "s": {
                "f": "-0700",
                "t": "-0800",
                "n": "PST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0800",
                "t": "-0700",
                "n": "PDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Lower_Princes",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Maceio",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Managua",
        {
            "s": {
                "f": "-0600",
                "n": "CST"
            }
        }
    ],
    [
        "America/Manaus",
        {
            "s": {
                "f": "-0400",
                "n": "-04"
            }
        }
    ],
    [
        "America/Marigot",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Martinique",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Matamoros",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Mazatlan",
        {
            "s": {
                "f": "-0600",
                "t": "-0700",
                "n": "MST",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "-0700",
                "t": "-0600",
                "n": "MDT",
                "s": "19700405T020000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Menominee",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Merida",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700405T020000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Metlakatla",
        {
            "s": {
                "f": "-0800",
                "t": "-0900",
                "n": "AKST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0900",
                "t": "-0800",
                "n": "AKDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Mexico_City",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700405T020000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Miquelon",
        {
            "s": {
                "f": "-0200",
                "t": "-0300",
                "n": "-03",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0300",
                "t": "-0200",
                "n": "-02",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Moncton",
        {
            "s": {
                "f": "-0300",
                "t": "-0400",
                "n": "AST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0400",
                "t": "-0300",
                "n": "ADT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Monterrey",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700405T020000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Montevideo",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Montserrat",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Nassau",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/New_York",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Nipigon",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Nome",
        {
            "s": {
                "f": "-0800",
                "t": "-0900",
                "n": "AKST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0900",
                "t": "-0800",
                "n": "AKDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Noronha",
        {
            "s": {
                "f": "-0200",
                "n": "-02"
            }
        }
    ],
    [
        "America/North_Dakota/Beulah",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/North_Dakota/Center",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/North_Dakota/New_Salem",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Ojinaga",
        {
            "s": {
                "f": "-0600",
                "t": "-0700",
                "n": "MST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0700",
                "t": "-0600",
                "n": "MDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Panama",
        {
            "s": {
                "f": "-0500",
                "n": "EST"
            }
        }
    ],
    [
        "America/Pangnirtung",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Paramaribo",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Phoenix",
        {
            "s": {
                "f": "-0700",
                "n": "MST"
            }
        }
    ],
    [
        "America/Port_of_Spain",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Port-au-Prince",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Porto_Velho",
        {
            "s": {
                "f": "-0400",
                "n": "-04"
            }
        }
    ],
    [
        "America/Puerto_Rico",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Punta_Arenas",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Rainy_River",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Rankin_Inlet",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Recife",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Regina",
        {
            "s": {
                "f": "-0600",
                "n": "CST"
            }
        }
    ],
    [
        "America/Resolute",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Rio_Branco",
        {
            "s": {
                "f": "-0500",
                "n": "-05"
            }
        }
    ],
    [
        "America/Santarem",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "America/Santiago",
        {
            "s": {
                "f": "-0300",
                "t": "-0400",
                "n": "-04",
                "s": "19700405T000000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0400",
                "t": "-0300",
                "n": "-03",
                "s": "19700906T000000",
                "r": {
                    "m": 9,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Santo_Domingo",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Sao_Paulo",
        {
            "s": {
                "f": "-0300",
                "n": "-03",
                "s": "19700215T000000",
                "r": {
                    "m": 2,
                    "d": "3SU"
                }
            },
            "d": {
                "f": "-0300",
                "t": "-0200",
                "n": "-02",
                "s": "19701101T000000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "America/Scoresbysund",
        {
            "s": {
                "f": "+0000",
                "t": "-0100",
                "n": "-01",
                "s": "19701025T010000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "-0100",
                "t": "+0000",
                "n": "+00",
                "s": "19700329T000000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "America/Sitka",
        {
            "s": {
                "f": "-0800",
                "t": "-0900",
                "n": "AKST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0900",
                "t": "-0800",
                "n": "AKDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/St_Barthelemy",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/St_Johns",
        {
            "s": {
                "f": "-0230",
                "t": "-0330",
                "n": "NST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0330",
                "t": "-0230",
                "n": "NDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/St_Kitts",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/St_Lucia",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/St_Thomas",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/St_Vincent",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Swift_Current",
        {
            "s": {
                "f": "-0600",
                "n": "CST"
            }
        }
    ],
    [
        "America/Tegucigalpa",
        {
            "s": {
                "f": "-0600",
                "n": "CST"
            }
        }
    ],
    [
        "America/Thule",
        {
            "s": {
                "f": "-0300",
                "t": "-0400",
                "n": "AST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0400",
                "t": "-0300",
                "n": "ADT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Thunder_Bay",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Tijuana",
        {
            "s": {
                "f": "-0700",
                "t": "-0800",
                "n": "PST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0800",
                "t": "-0700",
                "n": "PDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Toronto",
        {
            "s": {
                "f": "-0400",
                "t": "-0500",
                "n": "EST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0500",
                "t": "-0400",
                "n": "EDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Tortola",
        {
            "s": {
                "f": "-0400",
                "n": "AST"
            }
        }
    ],
    [
        "America/Vancouver",
        {
            "s": {
                "f": "-0700",
                "t": "-0800",
                "n": "PST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0800",
                "t": "-0700",
                "n": "PDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Whitehorse",
        {
            "s": {
                "f": "-0700",
                "t": "-0800",
                "n": "PST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0800",
                "t": "-0700",
                "n": "PDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Winnipeg",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "CST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "CDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Yakutat",
        {
            "s": {
                "f": "-0800",
                "t": "-0900",
                "n": "AKST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0900",
                "t": "-0800",
                "n": "AKDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "America/Yellowknife",
        {
            "s": {
                "f": "-0600",
                "t": "-0700",
                "n": "MST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0700",
                "t": "-0600",
                "n": "MDT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "Antarctica/Casey",
        {
            "s": {
                "f": "+0800",
                "n": "+08"
            }
        }
    ],
    [
        "Antarctica/Davis",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Antarctica/DumontDUrville",
        {
            "s": {
                "f": "+1000",
                "n": "+10"
            }
        }
    ],
    [
        "Antarctica/Macquarie",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Antarctica/Mawson",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Antarctica/McMurdo",
        {
            "s": {
                "f": "+1300",
                "t": "+1200",
                "n": "NZST",
                "s": "19700405T030000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+1200",
                "t": "+1300",
                "n": "NZDT",
                "s": "19700927T020000",
                "r": {
                    "m": 9,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Antarctica/Palmer",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "Antarctica/Rothera",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "Antarctica/Syowa",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Antarctica/Troll",
        {
            "s": {
                "f": "+0200",
                "t": "+0000",
                "n": "+00",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0000",
                "t": "+0200",
                "n": "+02",
                "s": "19700329T010000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Antarctica/Vostok",
        {
            "s": {
                "f": "+0600",
                "n": "+06"
            }
        }
    ],
    [
        "Arctic/Longyearbyen",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Asia/Aden",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Asia/Almaty",
        {
            "s": {
                "f": "+0600",
                "n": "+06"
            }
        }
    ],
    [
        "Asia/Amman",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701030T010000",
                "r": {
                    "m": 10,
                    "d": "-1FR"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700326T235959",
                "r": {
                    "m": 3,
                    "d": "-1TH"
                }
            }
        }
    ],
    [
        "Asia/Anadyr",
        {
            "s": {
                "f": "+1200",
                "n": "+12"
            }
        }
    ],
    [
        "Asia/Aqtau",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Asia/Aqtobe",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Asia/Ashgabat",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Asia/Atyrau",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Asia/Baghdad",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Asia/Bahrain",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Asia/Baku",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Asia/Bangkok",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Asia/Barnaul",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Asia/Beirut",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T000000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T000000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Asia/Bishkek",
        {
            "s": {
                "f": "+0600",
                "n": "+06"
            }
        }
    ],
    [
        "Asia/Brunei",
        {
            "s": {
                "f": "+0800",
                "n": "+08"
            }
        }
    ],
    [
        "Asia/Chita",
        {
            "s": {
                "f": "+0900",
                "n": "+09"
            }
        }
    ],
    [
        "Asia/Choibalsan",
        {
            "s": {
                "f": "+0800",
                "n": "+08"
            }
        }
    ],
    [
        "Asia/Colombo",
        {
            "s": {
                "f": "+0530",
                "n": "+0530"
            }
        }
    ],
    [
        "Asia/Damascus",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701030T000000",
                "r": {
                    "m": 10,
                    "d": "-1FR"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700327T000000",
                "r": {
                    "m": 3,
                    "d": "-1FR"
                }
            }
        }
    ],
    [
        "Asia/Dhaka",
        {
            "s": {
                "f": "+0600",
                "n": "+06"
            }
        }
    ],
    [
        "Asia/Dili",
        {
            "s": {
                "f": "+0900",
                "n": "+09"
            }
        }
    ],
    [
        "Asia/Dubai",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Asia/Dushanbe",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Asia/Famagusta",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Asia/Gaza",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701031T010000",
                "r": {
                    "m": 10,
                    "d": "-1SA"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700328T010000",
                "r": {
                    "m": 3,
                    "d": "4SA"
                }
            }
        }
    ],
    [
        "Asia/Hebron",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701031T010000",
                "r": {
                    "m": 10,
                    "d": "-1SA"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700328T010000",
                "r": {
                    "m": 3,
                    "d": "4SA"
                }
            }
        }
    ],
    [
        "Asia/Ho_Chi_Minh",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Asia/Hong_Kong",
        {
            "s": {
                "f": "+0800",
                "n": "HKT"
            }
        }
    ],
    [
        "Asia/Hovd",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Asia/Irkutsk",
        {
            "s": {
                "f": "+0800",
                "n": "+08"
            }
        }
    ],
    [
        "Asia/Istanbul",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Asia/Jakarta",
        {
            "s": {
                "f": "+0700",
                "n": "WIB"
            }
        }
    ],
    [
        "Asia/Jayapura",
        {
            "s": {
                "f": "+0900",
                "n": "WIT"
            }
        }
    ],
    [
        "Asia/Jerusalem",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "IST",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "IDT",
                "s": "19700327T020000",
                "r": {
                    "m": 3,
                    "d": "-1FR"
                }
            }
        }
    ],
    [
        "Asia/Kabul",
        {
            "s": {
                "f": "+0430",
                "n": "+0430"
            }
        }
    ],
    [
        "Asia/Kamchatka",
        {
            "s": {
                "f": "+1200",
                "n": "+12"
            }
        }
    ],
    [
        "Asia/Karachi",
        {
            "s": {
                "f": "+0500",
                "n": "PKT"
            }
        }
    ],
    [
        "Asia/Kathmandu",
        {
            "s": {
                "f": "+0545",
                "n": "+0545"
            }
        }
    ],
    [
        "Asia/Khandyga",
        {
            "s": {
                "f": "+0900",
                "n": "+09"
            }
        }
    ],
    [
        "Asia/Kolkata",
        {
            "s": {
                "f": "+0530",
                "n": "IST"
            }
        }
    ],
    [
        "Asia/Krasnoyarsk",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Asia/Kuala_Lumpur",
        {
            "s": {
                "f": "+0800",
                "n": "+08"
            }
        }
    ],
    [
        "Asia/Kuching",
        {
            "s": {
                "f": "+0800",
                "n": "+08"
            }
        }
    ],
    [
        "Asia/Kuwait",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Asia/Macau",
        {
            "s": {
                "f": "+0800",
                "n": "CST"
            }
        }
    ],
    [
        "Asia/Magadan",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Asia/Makassar",
        {
            "s": {
                "f": "+0800",
                "n": "WITA"
            }
        }
    ],
    [
        "Asia/Manila",
        {
            "s": {
                "f": "+0800",
                "n": "PST"
            }
        }
    ],
    [
        "Asia/Muscat",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Asia/Nicosia",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Asia/Novokuznetsk",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Asia/Novosibirsk",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Asia/Omsk",
        {
            "s": {
                "f": "+0600",
                "n": "+06"
            }
        }
    ],
    [
        "Asia/Oral",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Asia/Phnom_Penh",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Asia/Pontianak",
        {
            "s": {
                "f": "+0700",
                "n": "WIB"
            }
        }
    ],
    [
        "Asia/Pyongyang",
        {
            "s": {
                "f": "+0900",
                "n": "KST"
            }
        }
    ],
    [
        "Asia/Qatar",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Asia/Qyzylorda",
        {
            "s": {
                "f": "+0600",
                "n": "+06"
            }
        }
    ],
    [
        "Asia/Riyadh",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Asia/Sakhalin",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Asia/Samarkand",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Asia/Seoul",
        {
            "s": {
                "f": "+0900",
                "n": "KST"
            }
        }
    ],
    [
        "Asia/Shanghai",
        {
            "s": {
                "f": "+0800",
                "n": "CST"
            }
        }
    ],
    [
        "Asia/Singapore",
        {
            "s": {
                "f": "+0800",
                "n": "+08"
            }
        }
    ],
    [
        "Asia/Srednekolymsk",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Asia/Taipei",
        {
            "s": {
                "f": "+0800",
                "n": "CST"
            }
        }
    ],
    [
        "Asia/Tashkent",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Asia/Tbilisi",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Asia/Tehran",
        {
            "s": {
                "f": "+0430",
                "t": "+0330",
                "n": "+0330",
                "s": "19700921T000000",
                "r": {
                    "m": 9,
                    "d": "3SU"
                }
            },
            "d": {
                "f": "+0330",
                "t": "+0430",
                "n": "+0430",
                "s": "19700321T000000",
                "r": {
                    "m": 3,
                    "d": "3SU"
                }
            }
        }
    ],
    [
        "Asia/Thimphu",
        {
            "s": {
                "f": "+0600",
                "n": "+06"
            }
        }
    ],
    [
        "Asia/Tokyo",
        {
            "s": {
                "f": "+0900",
                "n": "JST"
            }
        }
    ],
    [
        "Asia/Tomsk",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Asia/Ulaanbaatar",
        {
            "s": {
                "f": "+0800",
                "n": "+08"
            }
        }
    ],
    [
        "Asia/Urumqi",
        {
            "s": {
                "f": "+0600",
                "n": "+06"
            }
        }
    ],
    [
        "Asia/Ust-Nera",
        {
            "s": {
                "f": "+1000",
                "n": "+10"
            }
        }
    ],
    [
        "Asia/Vientiane",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Asia/Vladivostok",
        {
            "s": {
                "f": "+1000",
                "n": "+10"
            }
        }
    ],
    [
        "Asia/Yakutsk",
        {
            "s": {
                "f": "+0900",
                "n": "+09"
            }
        }
    ],
    [
        "Asia/Yangon",
        {
            "s": {
                "f": "+0630",
                "n": "+0630"
            }
        }
    ],
    [
        "Asia/Yekaterinburg",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Asia/Yerevan",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Atlantic/Azores",
        {
            "s": {
                "f": "+0000",
                "t": "-0100",
                "n": "-01",
                "s": "19701025T010000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "-0100",
                "t": "+0000",
                "n": "+00",
                "s": "19700329T000000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Atlantic/Bermuda",
        {
            "s": {
                "f": "-0300",
                "t": "-0400",
                "n": "AST",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "-0400",
                "t": "-0300",
                "n": "ADT",
                "s": "19700308T020000",
                "r": {
                    "m": 3,
                    "d": "2SU"
                }
            }
        }
    ],
    [
        "Atlantic/Canary",
        {
            "s": {
                "f": "+0100",
                "t": "+0000",
                "n": "WET",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0000",
                "t": "+0100",
                "n": "WEST",
                "s": "19700329T010000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Atlantic/Cape_Verde",
        {
            "s": {
                "f": "-0100",
                "n": "-01"
            }
        }
    ],
    [
        "Atlantic/Faroe",
        {
            "s": {
                "f": "+0100",
                "t": "+0000",
                "n": "WET",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0000",
                "t": "+0100",
                "n": "WEST",
                "s": "19700329T010000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Atlantic/Madeira",
        {
            "s": {
                "f": "+0100",
                "t": "+0000",
                "n": "WET",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0000",
                "t": "+0100",
                "n": "WEST",
                "s": "19700329T010000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Atlantic/Reykjavik",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Atlantic/South_Georgia",
        {
            "s": {
                "f": "-0200",
                "n": "-02"
            }
        }
    ],
    [
        "Atlantic/St_Helena",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Atlantic/Stanley",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "Australia/Adelaide",
        {
            "s": {
                "f": "+1030",
                "t": "+0930",
                "n": "ACST",
                "s": "19700405T030000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+0930",
                "t": "+1030",
                "n": "ACDT",
                "s": "19701004T020000",
                "r": {
                    "m": 10,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "Australia/Brisbane",
        {
            "s": {
                "f": "+1000",
                "n": "AEST"
            }
        }
    ],
    [
        "Australia/Broken_Hill",
        {
            "s": {
                "f": "+1030",
                "t": "+0930",
                "n": "ACST",
                "s": "19700405T030000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+0930",
                "t": "+1030",
                "n": "ACDT",
                "s": "19701004T020000",
                "r": {
                    "m": 10,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "Australia/Currie",
        {
            "s": {
                "f": "+1100",
                "t": "+1000",
                "n": "AEST",
                "s": "19700405T030000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+1000",
                "t": "+1100",
                "n": "AEDT",
                "s": "19701004T020000",
                "r": {
                    "m": 10,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "Australia/Darwin",
        {
            "s": {
                "f": "+0930",
                "n": "ACST"
            }
        }
    ],
    [
        "Australia/Eucla",
        {
            "s": {
                "f": "+0845",
                "n": "+0845"
            }
        }
    ],
    [
        "Australia/Hobart",
        {
            "s": {
                "f": "+1100",
                "t": "+1000",
                "n": "AEST",
                "s": "19700405T030000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+1000",
                "t": "+1100",
                "n": "AEDT",
                "s": "19701004T020000",
                "r": {
                    "m": 10,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "Australia/Lindeman",
        {
            "s": {
                "f": "+1000",
                "n": "AEST"
            }
        }
    ],
    [
        "Australia/Lord_Howe",
        {
            "s": {
                "f": "+1100",
                "t": "+1030",
                "n": "+1030",
                "s": "19700405T020000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+1030",
                "t": "+1100",
                "n": "+11",
                "s": "19701004T020000",
                "r": {
                    "m": 10,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "Australia/Melbourne",
        {
            "s": {
                "f": "+1100",
                "t": "+1000",
                "n": "AEST",
                "s": "19700405T030000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+1000",
                "t": "+1100",
                "n": "AEDT",
                "s": "19701004T020000",
                "r": {
                    "m": 10,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "Australia/Perth",
        {
            "s": {
                "f": "+0800",
                "n": "AWST"
            }
        }
    ],
    [
        "Australia/Sydney",
        {
            "s": {
                "f": "+1100",
                "t": "+1000",
                "n": "AEST",
                "s": "19700405T030000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+1000",
                "t": "+1100",
                "n": "AEDT",
                "s": "19701004T020000",
                "r": {
                    "m": 10,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "Etc/GMT-0",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Etc/GMT-1",
        {
            "s": {
                "f": "-0100",
                "n": "-01"
            }
        }
    ],
    [
        "Etc/GMT-10",
        {
            "s": {
                "f": "-1000",
                "n": "-10"
            }
        }
    ],
    [
        "Etc/GMT-11",
        {
            "s": {
                "f": "-1100",
                "n": "-11"
            }
        }
    ],
    [
        "Etc/GMT-12",
        {
            "s": {
                "f": "-1200",
                "n": "-12"
            }
        }
    ],
    [
        "Etc/GMT-2",
        {
            "s": {
                "f": "-0200",
                "n": "-02"
            }
        }
    ],
    [
        "Etc/GMT-3",
        {
            "s": {
                "f": "-0300",
                "n": "-03"
            }
        }
    ],
    [
        "Etc/GMT-4",
        {
            "s": {
                "f": "-0400",
                "n": "-04"
            }
        }
    ],
    [
        "Etc/GMT-5",
        {
            "s": {
                "f": "-0500",
                "n": "-05"
            }
        }
    ],
    [
        "Etc/GMT-6",
        {
            "s": {
                "f": "-0600",
                "n": "-06"
            }
        }
    ],
    [
        "Etc/GMT-7",
        {
            "s": {
                "f": "-0700",
                "n": "-07"
            }
        }
    ],
    [
        "Etc/GMT-8",
        {
            "s": {
                "f": "-0800",
                "n": "-08"
            }
        }
    ],
    [
        "Etc/GMT-9",
        {
            "s": {
                "f": "-0900",
                "n": "-09"
            }
        }
    ],
    [
        "Etc/GMT",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Etc/GMT+0",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Etc/GMT+1",
        {
            "s": {
                "f": "+0100",
                "n": "+01"
            }
        }
    ],
    [
        "Etc/GMT+10",
        {
            "s": {
                "f": "+1000",
                "n": "+10"
            }
        }
    ],
    [
        "Etc/GMT+11",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Etc/GMT+12",
        {
            "s": {
                "f": "+1200",
                "n": "+12"
            }
        }
    ],
    [
        "Etc/GMT+13",
        {
            "s": {
                "f": "+1300",
                "n": "+13"
            }
        }
    ],
    [
        "Etc/GMT+14",
        {
            "s": {
                "f": "+1400",
                "n": "+14"
            }
        }
    ],
    [
        "Etc/GMT+2",
        {
            "s": {
                "f": "+0200",
                "n": "+02"
            }
        }
    ],
    [
        "Etc/GMT+3",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Etc/GMT+4",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Etc/GMT+5",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Etc/GMT+6",
        {
            "s": {
                "f": "+0600",
                "n": "+06"
            }
        }
    ],
    [
        "Etc/GMT+7",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Etc/GMT+8",
        {
            "s": {
                "f": "+0800",
                "n": "+08"
            }
        }
    ],
    [
        "Etc/GMT+9",
        {
            "s": {
                "f": "+0900",
                "n": "+09"
            }
        }
    ],
    [
        "Etc/GMT0",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Etc/Greenwich",
        {
            "s": {
                "f": "+0000",
                "n": "GMT"
            }
        }
    ],
    [
        "Etc/UCT",
        {
            "s": {
                "f": "+0000",
                "n": "UCT"
            }
        }
    ],
    [
        "Etc/Universal",
        {
            "s": {
                "f": "+0000",
                "n": "UTC"
            }
        }
    ],
    [
        "Etc/UTC",
        {
            "s": {
                "f": "+0000",
                "n": "UTC"
            }
        }
    ],
    [
        "Etc/Zulu",
        {
            "s": {
                "f": "+0000",
                "n": "UTC"
            }
        }
    ],
    [
        "Europe/Amsterdam",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Andorra",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Astrakhan",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Europe/Athens",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Belgrade",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Berlin",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Bratislava",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Brussels",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Bucharest",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Budapest",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Busingen",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Chisinau",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Copenhagen",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Dublin",
        {
            "s": {
                "f": "+0100",
                "t": "+0000",
                "n": "GMT",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0000",
                "t": "+0100",
                "n": "IST",
                "s": "19700329T010000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Gibraltar",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Guernsey",
        {
            "s": {
                "f": "+0100",
                "t": "+0000",
                "n": "GMT",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0000",
                "t": "+0100",
                "n": "BST",
                "s": "19700329T010000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Helsinki",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Isle_of_Man",
        {
            "s": {
                "f": "+0100",
                "t": "+0000",
                "n": "GMT",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0000",
                "t": "+0100",
                "n": "BST",
                "s": "19700329T010000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Istanbul",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Europe/Jersey",
        {
            "s": {
                "f": "+0100",
                "t": "+0000",
                "n": "GMT",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0000",
                "t": "+0100",
                "n": "BST",
                "s": "19700329T010000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Kaliningrad",
        {
            "s": {
                "f": "+0200",
                "n": "EET"
            }
        }
    ],
    [
        "Europe/Kiev",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Kirov",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Europe/Lisbon",
        {
            "s": {
                "f": "+0100",
                "t": "+0000",
                "n": "WET",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0000",
                "t": "+0100",
                "n": "WEST",
                "s": "19700329T010000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Ljubljana",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/London",
        {
            "s": {
                "f": "+0100",
                "t": "+0000",
                "n": "GMT",
                "s": "19701025T020000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0000",
                "t": "+0100",
                "n": "BST",
                "s": "19700329T010000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Luxembourg",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Madrid",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Malta",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Mariehamn",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Minsk",
        {
            "s": {
                "f": "+0300",
                "n": "+03"
            }
        }
    ],
    [
        "Europe/Monaco",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Moscow",
        {
            "s": {
                "f": "+0300",
                "n": "MSK"
            }
        }
    ],
    [
        "Europe/Nicosia",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Oslo",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Paris",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Podgorica",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Prague",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Riga",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Rome",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Samara",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Europe/San_Marino",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Sarajevo",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Saratov",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Europe/Simferopol",
        {
            "s": {
                "f": "+0300",
                "n": "MSK"
            }
        }
    ],
    [
        "Europe/Skopje",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Sofia",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Stockholm",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Tallinn",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Tirane",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Ulyanovsk",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Europe/Uzhgorod",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Vaduz",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Vatican",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Vienna",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Vilnius",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Volgograd",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Europe/Warsaw",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Zagreb",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Zaporozhye",
        {
            "s": {
                "f": "+0300",
                "t": "+0200",
                "n": "EET",
                "s": "19701025T040000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0200",
                "t": "+0300",
                "n": "EEST",
                "s": "19700329T030000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Europe/Zurich",
        {
            "s": {
                "f": "+0200",
                "t": "+0100",
                "n": "CET",
                "s": "19701025T030000",
                "r": {
                    "m": 10,
                    "d": "-1SU"
                }
            },
            "d": {
                "f": "+0100",
                "t": "+0200",
                "n": "CEST",
                "s": "19700329T020000",
                "r": {
                    "m": 3,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Indian/Antananarivo",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Indian/Chagos",
        {
            "s": {
                "f": "+0600",
                "n": "+06"
            }
        }
    ],
    [
        "Indian/Christmas",
        {
            "s": {
                "f": "+0700",
                "n": "+07"
            }
        }
    ],
    [
        "Indian/Cocos",
        {
            "s": {
                "f": "+0630",
                "n": "+0630"
            }
        }
    ],
    [
        "Indian/Comoro",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Indian/Kerguelen",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Indian/Mahe",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Indian/Maldives",
        {
            "s": {
                "f": "+0500",
                "n": "+05"
            }
        }
    ],
    [
        "Indian/Mauritius",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Indian/Mayotte",
        {
            "s": {
                "f": "+0300",
                "n": "EAT"
            }
        }
    ],
    [
        "Indian/Reunion",
        {
            "s": {
                "f": "+0400",
                "n": "+04"
            }
        }
    ],
    [
        "Pacific/Apia",
        {
            "s": {
                "f": "+1400",
                "t": "+1300",
                "n": "+13",
                "s": "19700405T040000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+1300",
                "t": "+1400",
                "n": "+14",
                "s": "19700927T030000",
                "r": {
                    "m": 9,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Pacific/Auckland",
        {
            "s": {
                "f": "+1300",
                "t": "+1200",
                "n": "NZST",
                "s": "19700405T030000",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+1200",
                "t": "+1300",
                "n": "NZDT",
                "s": "19700927T020000",
                "r": {
                    "m": 9,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Pacific/Bougainville",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Pacific/Chatham",
        {
            "s": {
                "f": "+1345",
                "t": "+1245",
                "n": "+1245",
                "s": "19700405T034500",
                "r": {
                    "m": 4,
                    "d": "1SU"
                }
            },
            "d": {
                "f": "+1245",
                "t": "+1345",
                "n": "+1345",
                "s": "19700927T024500",
                "r": {
                    "m": 9,
                    "d": "-1SU"
                }
            }
        }
    ],
    [
        "Pacific/Chuuk",
        {
            "s": {
                "f": "+1000",
                "n": "+10"
            }
        }
    ],
    [
        "Pacific/Easter",
        {
            "s": {
                "f": "-0500",
                "t": "-0600",
                "n": "-06",
                "s": "19700404T220000",
                "r": {
                    "m": 4,
                    "d": "1SA"
                }
            },
            "d": {
                "f": "-0600",
                "t": "-0500",
                "n": "-05",
                "s": "19700905T220000",
                "r": {
                    "m": 9,
                    "d": "1SA"
                }
            }
        }
    ],
    [
        "Pacific/Efate",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Pacific/Enderbury",
        {
            "s": {
                "f": "+1300",
                "n": "+13"
            }
        }
    ],
    [
        "Pacific/Fakaofo",
        {
            "s": {
                "f": "+1300",
                "n": "+13"
            }
        }
    ],
    [
        "Pacific/Fiji",
        {
            "s": {
                "f": "+1300",
                "t": "+1200",
                "n": "+12",
                "s": "19700118T030000",
                "r": {
                    "m": 1,
                    "d": "-2SU"
                }
            },
            "d": {
                "f": "+1200",
                "t": "+1300",
                "n": "+13",
                "s": "19701101T020000",
                "r": {
                    "m": 11,
                    "d": "1SU"
                }
            }
        }
    ],
    [
        "Pacific/Funafuti",
        {
            "s": {
                "f": "+1200",
                "n": "+12"
            }
        }
    ],
    [
        "Pacific/Galapagos",
        {
            "s": {
                "f": "-0600",
                "n": "-06"
            }
        }
    ],
    [
        "Pacific/Gambier",
        {
            "s": {
                "f": "-0900",
                "n": "-09"
            }
        }
    ],
    [
        "Pacific/Guadalcanal",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Pacific/Guam",
        {
            "s": {
                "f": "+1000",
                "n": "ChST"
            }
        }
    ],
    [
        "Pacific/Honolulu",
        {
            "s": {
                "f": "-1000",
                "n": "HST"
            }
        }
    ],
    [
        "Pacific/Kiritimati",
        {
            "s": {
                "f": "+1400",
                "n": "+14"
            }
        }
    ],
    [
        "Pacific/Kosrae",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Pacific/Kwajalein",
        {
            "s": {
                "f": "+1200",
                "n": "+12"
            }
        }
    ],
    [
        "Pacific/Majuro",
        {
            "s": {
                "f": "+1200",
                "n": "+12"
            }
        }
    ],
    [
        "Pacific/Marquesas",
        {
            "s": {
                "f": "-0930",
                "n": "-0930"
            }
        }
    ],
    [
        "Pacific/Midway",
        {
            "s": {
                "f": "-1100",
                "n": "SST"
            }
        }
    ],
    [
        "Pacific/Nauru",
        {
            "s": {
                "f": "+1200",
                "n": "+12"
            }
        }
    ],
    [
        "Pacific/Niue",
        {
            "s": {
                "f": "-1100",
                "n": "-11"
            }
        }
    ],
    [
        "Pacific/Norfolk",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Pacific/Noumea",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Pacific/Pago_Pago",
        {
            "s": {
                "f": "-1100",
                "n": "SST"
            }
        }
    ],
    [
        "Pacific/Palau",
        {
            "s": {
                "f": "+0900",
                "n": "+09"
            }
        }
    ],
    [
        "Pacific/Pitcairn",
        {
            "s": {
                "f": "-0800",
                "n": "-08"
            }
        }
    ],
    [
        "Pacific/Pohnpei",
        {
            "s": {
                "f": "+1100",
                "n": "+11"
            }
        }
    ],
    [
        "Pacific/Port_Moresby",
        {
            "s": {
                "f": "+1000",
                "n": "+10"
            }
        }
    ],
    [
        "Pacific/Rarotonga",
        {
            "s": {
                "f": "-1000",
                "n": "-10"
            }
        }
    ],
    [
        "Pacific/Saipan",
        {
            "s": {
                "f": "+1000",
                "n": "ChST"
            }
        }
    ],
    [
        "Pacific/Tahiti",
        {
            "s": {
                "f": "-1000",
                "n": "-10"
            }
        }
    ],
    [
        "Pacific/Tarawa",
        {
            "s": {
                "f": "+1200",
                "n": "+12"
            }
        }
    ],
    [
        "Pacific/Tongatapu",
        {
            "s": {
                "f": "+1300",
                "n": "+13"
            }
        }
    ],
    [
        "Pacific/Wake",
        {
            "s": {
                "f": "+1200",
                "n": "+12"
            }
        }
    ],
    [
        "Pacific/Wallis",
        {
            "s": {
                "f": "+1200",
                "n": "+12"
            }
        }
    ]
]);
